import React, { FC } from 'react'

import checkmark from './checkmark.svg'
import classes from './LargeTick.module.scss'

export const LargeTick: FC = () => (
  <div className={classes.largeTickWrapper}>
    <img alt="A checkmark icon" src={checkmark} />
  </div>
)

export default LargeTick
